import { urls } from '@repo/app-constants';
import { Button } from '@repo/ui';

import { useTinyPlusNavState } from 'hooks/useTinyPlusNavState';

import styles from './TinyPlusNav.module.css';

type TinyPlusUpgradeButtonProps = {
  onClick?: () => void;
};

export const TinyPlusUpgradeButton = ({
  onClick,
}: TinyPlusUpgradeButtonProps) => {
  const { showUpgradeCta } = useTinyPlusNavState();
  if (!showUpgradeCta) return null;
  return (
    <Button
      href={urls.TINY_PLUS_UPGRADE_OFFER}
      external
      variant='outline'
      color='purple'
      iconNameLeft='awardFilled'
      label='Upgrade to Tiny+'
      width='full'
      className={styles.upgradeButton}
      onClick={onClick}
    />
  );
};

export default TinyPlusUpgradeButton;
